import ContractDistributionsService from "@/api/services/contractDistributions";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    categoryOptions: (state) => {
      const options = new Map();
      state.index.forEach(({ category, translatedCategory }) => {
        options.set(category, { label: translatedCategory, value: category });
      });
      return [...options.values()];
    },
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.contractDistributions;
      state.currentPage = data.page.currentPage || 1;
      state.totalPages = data.page.totalPages || 0;
      state.totalCount = data.page.totalCount || 0;
    },
  },
  actions: {
    async fetchIndex({ commit }, params = {}) {
      const response = await ContractDistributionsService.fetchIndex(params);
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data);
      return response;
    },
  },
};
